import { get } from 'lodash';
import { IConfiguration, IOrder, OrderStatus, canOrderBeCancelled } from 'next-common';
import { isStockOrder } from '../../common';

const customerOrderStatus = ['Invoiced/Closed', 'Fakturert/Avsluttet'];

export const isOrderInvoiced = (order: IOrder): boolean => {
  return customerOrderStatus.includes(get(order, 'vehicleOrderStatus.customerOrderStatus', null));
};

export const isOrderCancellable = (order: IOrder, configuration: IConfiguration): boolean => {
  const availabelity =
    canOrderBeCancelled(configuration, order) &&
    (get(order, 'isEditOrder', false) ||
      get(order, 'status', null) === OrderStatus[OrderStatus?.CANCEL_ORDER_FAILED] ||
      get(order, 'status', null) === OrderStatus[OrderStatus?.CANCEL_ORDER_PENDING] ||
      get(order, 'status', null) === OrderStatus[OrderStatus?.CANCEL_ORDER_SUCCESS]) &&
    !isOrderInvoiced(order) &&
    !isStockOrder(order?.lead?.orderType);

  return availabelity;
};

export const checkIfBrukskodeEnabled = (configuration: IConfiguration): boolean => {
  if (configuration?.features?.varebil?.isBrukskodeEnabled) {
    return true;
  }
  return false;
};

export const isOrderInvoicedSuccessFromIFS = (order: IOrder): boolean => {
  const isInvoiced = isOrderInvoiced(order);
  const ifsSuccess = get(order, 'vehicleOrderStatus.ifsStatus', null) === 'SUCCESS';
  return isInvoiced && ifsSuccess;
};
